import PromoModal from './PromoModal'

export default PromoModal
